import { css } from '@emotion/css';

export const cardHome = css`
    height: 50vw!important;
    max-height: 250px!important;
    min-height: 175px!important;
`;